import { Stack, Typography } from '@mui/material';
import { WandLoader } from '@opengov/components-wand-loader';

import { FULL_PAGE_WAND_LOADER_SIZE } from '../FullPageWandLoader';

interface RemoteModuleWandLoaderProps {
  /**
   * Optional status message below the wand (e.g. remote module retry progress).
   * Omitted on the first load attempt so the UI stays minimal.
   */
  message?: string;
}

/**
 * In-layout wand loader while a remote module script loads or mounts.
 * Fills the shell content area (nav visible) — not `100vh` like boot {@link FullPageWandLoader}.
 */
export function RemoteModuleWandLoader({ message }: RemoteModuleWandLoaderProps) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 400,
      }}
    >
      <Stack spacing={2} alignItems="center">
        <WandLoader size={FULL_PAGE_WAND_LOADER_SIZE} />
        {message && (
          <Typography
            variant="body2"
            color="text.secondary"
            data-testid="psp-loading-spinner-message"
            aria-live="polite"
          >
            {message}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
